import React, { useState } from 'react';
// @import components
import SVG from 'components/renderSvg';
// @import media
import toggleIcon from 'media/svgs/toggledown.svg';

const InfoSection = ({ title, children, isShodow = false, className }) => {
  const [isToggle, setIsToggle] = useState(true);
  return (
    <div>
      <div
        className={`mt-1 flex  items-center justify-between rounded-t-[20px] bg-[#E0E3E6] px-4 py-3 text-[14px] font-medium text-primary ${className}`}
      >
        <span> {title}</span>
        <SVG
          icon={toggleIcon}
          onClick={() => setIsToggle(prev => !prev)}
          className={`cursor-pointer transition-transform duration-300 ${
            !isToggle ? 'rotate-180' : 'rotate-0'
          }`}
        />
      </div>

      <div
        className={`transition-all duration-300 
    ${isToggle ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'} 
    overflow-hidden rounded-b-[20px] bg-white p-3 
    ${isShodow ? 'shadow-md' : ''}`}
      >
        {children}
      </div>
    </div>
  );
};

export default InfoSection;
